import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { makeStyles } from '@mui/styles';
import {
  Typography,
  Button,
  FormControl,
  TextField,
  useTheme,
} from '@mui/material';
import { useNavigate, Link } from 'react-router-dom';
import validateEmail from '../../Helpers/Validation/validateEmail';
import '../../Styles/login.scss';

const useStyles = makeStyles((theme) => ({
  img: {
    height: '100%',
    width: '100%',
  },
  accessButton: {
    borderRadius: '25px',
    color: theme.palette.primary.main,
  },
  lgtextfield: {
    '& .MuiOutlinedInput-root': {
      color: theme.palette.white.main,
      '& fieldset': {
        borderColor: theme.palette.white.main,
      },
      '&:hover fieldset': {
        borderColor: theme.palette.white.main,
      },
      '&.Mui-focused fieldset': {
        borderColor: theme.palette.white.main,
      },
    },
  },

  formLogin: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    width: '350px',
  },
}));

const ForgotPasswordPage = function ForgotPasswordPage() {
  const classes = useStyles();
  const theme = useTheme();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [submitClicked, setSubmitClicked] = useState(false);
  const intl = useIntl();

  const writeSubtitle = () => {
    let sub = intl.messages.INSERT_YOUR_CREDENTIALS;
    if (submitClicked) {
      if (email === '') sub = intl.messages.MISSING_MANDATORY_FIELDS;
      else if (validateEmail(email))
        sub = intl.messages.INSERT_YOUR_CREDENTIALS;
      else sub = intl.messages.INVALID_EMAIL_ADDRESS;
    }
    return sub;
  };
  const setSubColor = () => {
    let color = theme.palette.white.main;
    if (submitClicked) {
      if (!validateEmail(email) || email === '')
        color = theme.palette.error.main;
      else color = theme.palette.white.main;
    }
    return color;
  };
  useEffect(() => {
    if (submitClicked && email !== '' && validateEmail(email)) {
      navigate('/'); //login page
    }
  }, [submitClicked]);

  return (
    <div className="forgotPwd">
      <div className="split left">
        {/* <img alt="dbe" src={LoginImage} className={classes.img} /> */}
      </div>
      <div className="split right">
        <div className="centered">
          <div className={classes.formLogin}>
            <Typography variant="caption" sx={{ fontSize: '30px' }}>
              {intl.messages.PASSWORD_RECOVERY}
            </Typography>
            <Typography
              variant="subtitle2"
              sx={{
                mb: 2,
                color: setSubColor()
              }}>
              {writeSubtitle()}
            </Typography>
            <FormControl sx={{ color: 'white.main', mb: 2 }}>
              <TextField
                error={
                  (email === '' && submitClicked) ||
                  (submitClicked && !validateEmail(email))
                }
                className={classes.lgtextfield}
                variant="outlined"
                placeholder={intl.messages.EMAIL}
                InputProps={{
                  className: classes.inputColor,
                }}
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  setSubmitClicked(false);
                }}
              />
            </FormControl>
            <Button
              sx={{
                backgroundColor: 'white.main',
                color: 'primary.main',
                mb: '2%',
              }}
              onClick={() => setSubmitClicked(true)}
            >
              {intl.messages.LOGIN}
            </Button>
            <Link
              to="/"
              style={{
                color: '#ffffff',
                fontFamily: 'Roboto',
                textDecoration: 'none',
              }}
            >
              {intl.messages.BACK_TO_LOGIN}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
